module.exports = __webpack_public_path__ + "resources/img/calendar.fca91d69.png";